import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("mm_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const previewUrl = (photoId) => `${API}/photos/${photoId}/preview`;

export const adminFileUrl = (subpath) => {
  const t = localStorage.getItem("mm_admin_token") || "";
  const sep = subpath.includes("?") ? "&" : "?";
  return `${API}${subpath}${sep}token=${encodeURIComponent(t)}`;
};

export const money = (cents, currency = "USD") =>
  new Intl.NumberFormat("en-US", { style: "currency", currency }).format((cents || 0) / 100);
